import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/misc'
import cx from 'classnames'
import onClickOutside from 'react-onclickoutside'

import styles from './button-dropdown.styl'

@onClickOutside
class ButtonDropdown extends Component {
  static propTypes = {
    actions: PropTypes.array.isRequired,
    className: PropTypes.string,
    right: PropTypes.bool,
    children: PropTypes.any.isRequired
  }
  static defaultProps = {
    actions: []
  }

  state = {
    visible: false
  }

  handleClick = () => {
    this.setState({
      visible: !this.state.visible
    })
  }

  handleClickOutside = () => {
    this.setState({
      visible: false
    })
  }

  render() {
    const { actions, children, className, right } = this.props
    const { visible } = this.state

    return (
      <div
        className={cx(styles.wrap, className, {
          [styles.active]: visible
        })}
      >
        <Button
          {...this.props}
          type="button"
          className={styles.btn}
          onClick={this.handleClick}
          appendComponent={
            <span className={`ico ico--chevron-down ${styles.ico}`} />
          }
        >
          {children}
        </Button>

        <ul className={cx(styles.list, { [styles.right]: right })}>
          {actions.map(item => {
            if (item.hide) {
              return null
            }

            return (
              <li
                key={item.id}
                className={cx(styles.item, {
                  [styles.negative]: item.negative
                })}
                onClick={item.onClick}
              >

                {item.intlKey
                  ? <FormattedMessage
                      id={item.intlKey}
                      defaultMessage={item.label}
                    />
                  : item.label}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default ButtonDropdown
